var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-muted"},[_vm._v(" ESTAGE Global Tracking is ON! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }